import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { IMAGES_URL, IMAGING } from '@src/app/core/constants';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [RouterLink],
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  type: any;
  title: any;
  desc: any;
  IMAGES_URL = IMAGES_URL;
  private sub: Subscription | any;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.type = this.route.snapshot.paramMap.get('type'); 

    this.sub = this.route.data.subscribe((param: any) => {
      if (param.type) {
        this.type = param.type;
      }
      if (param.title) {
        this.title = param.title;
      }
      if (param.desc) {
        this.desc = param.desc;
      }
    });

    switch (this.type) {
      case '404': 
        if (!this.title) {
          this.title = 'Oops! This page is missing';
        }
        if (!this.desc) {
          this.desc = 'Looks like you’ve taken a wrong turn. The page you’re looking for doesn’t exist..';
        }
        break;
      case '500':
        if (!this.title) {
          this.title = 'Internal server error';
        }
        if (!this.desc) {
          this.desc = 'Oopps!! There wan an error. Please try agin later.';
        }
        break;
      default:
        // if (!this.type) {
        this.type = 'Ooops..';
        // }
        if (!this.title) {
          this.title = 'Oops! This page is missing';
        }
        if (!this.desc) {
          this.desc = 'Looks like you’ve taken a wrong turn. The page you’re looking for doesn’t exist..';
        }
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
